import React from 'react';
import { TFunction } from 'i18next';
import { Field } from 'formik';
import { Select } from 'formik-material-ui';
import { FormControl, MenuItem } from '@mui/material';

import { SUPPORTED_LANGUAGES, LANGUAGE_NATIVE_NAMES } from 'i18n/languages';

interface LanguageFieldProps {
  t: TFunction;
  currentLanguage: string;
  handleLanguageChange: (language: string) => void;
}

const languageOptions = SUPPORTED_LANGUAGES.map((code) => ({
  value: code,
  label: LANGUAGE_NATIVE_NAMES[code],
}));

export default function LanguageField({
  t,
  currentLanguage,
  handleLanguageChange,
}: LanguageFieldProps): JSX.Element {
  return (
    <FormControl fullWidth>
      <Field
        component={Select}
        name="language"
        label={t('Language')}
        value={currentLanguage}
        onChange={(event: React.ChangeEvent<{ value: unknown }>) =>
          handleLanguageChange(event.target.value as string)
        }
      >
        {languageOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Field>
    </FormControl>
  );
}
